import { render, staticRenderFns } from "./MarketingFormSenders.vue?vue&type=template&id=f4c9f948&scoped=true"
import script from "./MarketingFormSenders.vue?vue&type=script&lang=js"
export * from "./MarketingFormSenders.vue?vue&type=script&lang=js"
import style0 from "./MarketingFormSenders.vue?vue&type=style&index=0&id=f4c9f948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c9f948",
  null
  
)

export default component.exports